module.exports = __webpack_public_path__ + "img/CircularEconomy.8232ef9d.png";